import { render, staticRenderFns } from "./partner_entities_vime_general_information.vue?vue&type=template&id=cd8d4f2c"
import script from "./partner_entities_vime_general_information.vue?vue&type=script&lang=js"
export * from "./partner_entities_vime_general_information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports